import { render, staticRenderFns } from "./relative_time.vue?vue&type=template&id=809609f4&"
import script from "./relative_time.vue?vue&type=script&lang=ts&"
export * from "./relative_time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports